/* eslint-disable import/no-named-as-default */
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import USER_ROLE from 'constants/role';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';

import PickerSmsButton from 'clientCommunications/components/Clients/common/PickerSmsButton.component';

export const PickerSmsSelections = ({ enableConfirm, onClick, permission, selections, variant }) => {
  const [showTip, setShowTip] = useState({});

  const isReceptionist = permission === USER_ROLE.receptionist;
  const isNotReceptionist = permission !== USER_ROLE.receptionist;

  const handleClick = useCallback(
    (index) => {
      if (isNotReceptionist || (isReceptionist && index === 0)) {
        onClick(index);
        enableConfirm(true);
      } else {
        enableConfirm(false);
      }
      setShowTip({ [index]: true });
    },
    [isNotReceptionist, isReceptionist, onClick, enableConfirm],
  );

  return (
    <>
      {selections.map((selection, index) => (
        <PickerSmsButton
          id={selection.id}
          label={selection.label}
          name={selection.name}
          checked={selection.checked}
          key={selection.id}
          role="button"
          tabIndex={-1}
          onClick={() => handleClick(index)}
          showDiscountLabel={selection.name === 'two_thousands'}
          smsCost={selection.smsCost}
          text={selection.text}
          discount="10"
          showTip={showTip[index] === true}
          permission={permission}
          disabled={isReceptionist && index !== 0}
          variant={variant}
        />
      ))}
    </>
  );
};

const PickerSmsSelectionsHoc = connect((state) => ({
  permission: selectEffectiveUserRole(state),
  salonId: selectCurrentSalonId(state),
}))(PickerSmsSelections);

export default PickerSmsSelectionsHoc;
